import React, {useState, useRef, useEffect} from "react";
import {useSelector} from "react-redux";
import {message, Breadcrumb, Form, Row, Col, Input, Space, Button, Cascader} from "antd";
import {LeftCircleOutlined, FileDoneOutlined} from "@ant-design/icons";
import ChuangShiOS from "chuangshi-os-website-component";

import Application from "../../common/Application";

import MerchantInput from "../merchant/Input";

import Style from "./Detail.module.css";

const ShopDetail = (props) => {
    const store = useSelector((store) => store);
    const [form] = Form.useForm();
    const request = useRef(false);
    const [isLoad, setIsLoad] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isSave, setIsSave] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [systemVersion, setSystemVersion] = useState(0);
    const [cityList, setCityList] = useState([]);

    useEffect(() => {
        if (store.main.userName) {
            ChuangShiOS.Notification.emit("main_menu_active", {url: "/shop/index"});

            switch (props.match.path) {
                case "/shop/add":
                    setIsSave(true);

                    break;
                case "/shop/edit/:shopId":
                    setIsEdit(true);

                    handleLoadShop();

                    break;
                default:
                    break;
            }

            handleLoadCity();
        }

        //eslint-disable-next-line
    }, [store.main.userName]);

    const handleLoadCity = () => {
        ChuangShiOS.Util.request(props, {
            url: Application.host + "/windeal/city/business/website/v1/cascader/list",
            data: {},
            success: (response) => {
                setCityList(response.data);
            },
            error: (response) => {
                message.error({content: response.message, duration: 1});
            },
            complete: (response) => {},
        });
    };

    const handleLoadShop = () => {
        if (request.current) {
            return;
        }
        request.current = true;

        setIsLoad(true);

        ChuangShiOS.Util.request(props, {
            url: Application.host + "/windeal/shop/business/website/v1/find",
            data: {
                shopId: props.match.params.shopId,
            },
            success: (response) => {
                response.data.provinceCity = [response.data.provinceId, response.data.cityId];

                form.setFieldsValue(response.data);

                setSystemVersion(response.data.systemVersion);
            },
            error: (response) => {
                message.error({content: response.message, duration: 1});
            },
            complete: (response) => {
                request.current = false;

                setIsLoad(false);
                setIsError(typeof response.data == "undefined" || typeof response.data.shopId == "undefined" || response.data.shopId == null);
            },
        });
    };

    const handleSubmitShop = () => {
        if (request.current) {
            return;
        }

        form.validateFields()
            .then((data) => {
                if (request.current) {
                    return;
                }
                request.current = true;

                setIsLoad(true);

                message.loading({
                    content: "正在加载",
                    key: "isLoad",
                    duration: 0,
                });

                data.shopId = props.match.params.shopId;
                data.provinceId = data.provinceCity[0];
                data.cityId = data.provinceCity[1];
                data.systemVersion = systemVersion;

                delete data.provinceCity;

                let url = "";
                if (isSave) {
                    url = "/windeal/shop/business/website/v1/save";
                }
                if (isEdit) {
                    url = "/windeal/shop/business/website/v1/update";
                }

                ChuangShiOS.Util.request(props, {
                    url: Application.host + url,
                    data: data,
                    success: (response) => {
                        message.success({
                            content: response.message,
                            key: "isLoad",
                            duration: 2,
                        });

                        request.current = false;

                        setIsLoad(false);

                        ChuangShiOS.Util.navigateBack(props, {});
                    },
                    error: (response) => {
                        message.error({
                            content: response.message,
                            key: "isLoad",
                            duration: 2,
                        });

                        request.current = false;

                        setIsLoad(false);
                    },
                    complete: (response) => {},
                });
            })
            .catch((response) => {
                ChuangShiOS.Util.parseResponseError(response);
            });
    };

    const handleBackShop = () => {
        ChuangShiOS.Util.navigateBack(props, {});
    };

    return (
        <div className={Style.page}>
            <div className={Style.header}>
                <div className={Style.header_title}>
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <span>首页</span>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <span>{store.main.menuName}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <div className={Style.header_title_text}>{store.main.sidebarName}</div>
                </div>
                <div className={Style.header_button}>
                    <Space>
                        <Button.Group>
                            <Button icon={<LeftCircleOutlined />} size="large" onClick={handleBackShop}>
                                返回
                            </Button>
                        </Button.Group>
                        <Button
                            loading={isLoad}
                            disabled={isError}
                            icon={<FileDoneOutlined />}
                            type="primary"
                            size="large"
                            onClick={handleSubmitShop}
                        >
                            提交
                        </Button>
                    </Space>
                </div>
            </div>
            <ChuangShiOS.Content
                className={Style.content}
                isLoad={isLoad}
                isEmpty={false}
                isError={isError}
                paddingTop={28}
                isScroll={store.main.isFixedContent}
            >
                <Row>
                    <Col flex="auto">
                        <div className={Style.card_title}>基本信息</div>
                    </Col>
                    <Col></Col>
                </Row>
                <Form form={form}>
                    <Row>
                        <Col span={12}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "24%"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="门店名称"
                                name="shopName"
                                initialValue={""}
                                rules={[
                                    {
                                        required: true,
                                        message: "请输入门店名称",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入门店名称" onPressEnter={handleSubmitShop} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "24%"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="门店代码"
                                name="shopCode"
                                initialValue={""}
                                rules={[
                                    {
                                        required: true,
                                        message: "请输入门店代码",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入门店代码" onPressEnter={handleSubmitShop} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "24%"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="商户名称"
                                name="merchantId"
                                initialValue={null}
                                rules={[
                                    {
                                        required: true,
                                        message: "请选择商户名称",
                                    },
                                ]}
                            >
                                <MerchantInput
                                    className={Style.card_field}
                                    placeholder={"请选择所属商户"}
                                    onQuery={(value) => {
                                        let data = form.getFieldsValue();

                                        if (!data.provinceCity) {
                                            form.setFieldsValue({
                                                provinceCity: [value.provinceId, value.cityId],
                                            });
                                        }
                                    }}
                                ></MerchantInput>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "24%"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="城市名称"
                                name="provinceCity"
                                initialValue={null}
                                rules={[
                                    {
                                        required: true,
                                        message: "请选择城市名称",
                                    },
                                ]}
                            >
                                <Cascader className={Style.card_field} allowClear options={cityList} placeholder="请选择城市名称" />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "12%"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="门店图片"
                                name="shopImage"
                                initialValue={""}
                                rules={[
                                    {
                                        required: false,
                                        message: "请选择门店图片",
                                    },
                                ]}
                            >
                                <ChuangShiOS.File fileType={"IMAGE"} limit={1} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "24%"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="门店经度"
                                name="shopLongitude"
                                initialValue={""}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入门店经度",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入门店经度" onPressEnter={handleSubmitShop} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "24%"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="门店维度"
                                name="shopLatitude"
                                initialValue={""}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入门店维度",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入门店维度" onPressEnter={handleSubmitShop} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "24%"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="门店电话"
                                name="shopTel"
                                initialValue={""}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入门店电话",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入门店电话" onPressEnter={handleSubmitShop} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "24%"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="门店地址"
                                name="shopAddress"
                                initialValue={""}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入门店地址",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入门店地址" onPressEnter={handleSubmitShop} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "12%"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="门店介绍"
                                name="shopContent"
                                initialValue={""}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入门店介绍",
                                    },
                                ]}
                            >
                                <ChuangShiOS.Editor placeholder="请输入门店介绍" />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </ChuangShiOS.Content>
            <div className={Style.footer}></div>
        </div>
    );
};

ShopDetail.propTypes = {};

ShopDetail.defaultProps = {};

export default ShopDetail;
